import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
  Alert,
  Row,
  Col,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import FieldInput from "../../global/form/FieldInput";
import TextLoading from "../../global/TextLoading";

// services
import { CreateGrade } from "../../../api/Cycles";
export default function AddGrade(props) {
  const [t] = useTranslation(["global", "class"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const schema = Yup.object().shape({
    grade: Yup.number().required(
      t("class:modalAddGrade.gradeLabel") +
        " " +
        t("class:classDetails.fieldRequired"),
    ),
    group: Yup.number().required(
      t("class:modalAddGrade.groupLabel") +
        " " +
        t("class:classDetails.fieldRequired"),
    ),
  });

  const obtainGradesAndGroups = (level) => {
    const gradesActive = level.grades.filter((grade) => grade.active == 1);
    let grades = gradesActive.map((grade) => ({
      id: grade.id,
      value: grade.id,
      label: grade.grade_level,
      groups: grade.groups
        .filter((group) => group.active == 1)
        .map((group) => ({
          id: group.id,
          value: group.id,
          label: group.name,
          gggl: group.grade_group_grade_level_id,
        })),
    }));
    return grades;
  };

  return (
    <Modal
      show={props.showModalAddGrade}
      aria-labelledby="contained-modal-title-lg"
      id="modalAddGrade"
    >
      <Modal.Header>
        <Modal.Title className="modal-title">
          {t("class:modalAddGrade.title")}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          grade: "",
          group: "",
        }}
        validationSchema={schema}
        onSubmit={(values) => {
          setIsSubmitting(true);
          const payload = {
            grade_level: values.grade,
            grade_groups: values.group,
            school_cycle_id: props.data.schoolCycleId,
            organization_school_level_id: props.data.organizationSchoolLevelId,
          };
          CreateGrade(payload).then((response) => {
            if (response.status) {
              const levels = response.data;
              const level = levels.find(
                (lvl) => lvl.id == props.data.organizationSchoolLevelId,
              );
              const grades = obtainGradesAndGroups(level);
              props.setGradesList(grades);
              props.setShowModalAddGrade(false);
            } else {
              setError(response.description);
            }
            setIsSubmitting(false);
          });
        }}
      >
        <Form>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <FieldInput
                  label={
                    <span>
                      {t("class:modalAddGrade.gradeLabel")}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="tooltip-group">
                            {t("class:modalAddGrade.gradeTooltip")}
                          </Tooltip>
                        }
                      >
                        <span
                          className="bi bi-question-circle-fill"
                          style={{
                            verticalAlign: "middle",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#EA2C54",
                            marginLeft: "4px",
                            paddingTop: "0px",
                          }}
                        ></span>
                      </OverlayTrigger>
                    </span>
                  }
                  id="grade"
                  name="grade"
                  type="number"
                  placeholder={3}
                  maxLength={2}
                />
              </Col>
              <Col md={6}>
                <FieldInput
                  label={
                    <span>
                      {t("class:modalAddGrade.groupLabel")}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="tooltip-group">
                            {t("class:modalAddGrade.groupTooltip")}
                          </Tooltip>
                        }
                      >
                        <span
                          className="bi bi-question-circle-fill"
                          style={{
                            verticalAlign: "middle",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#EA2C54",
                            marginLeft: "4px",
                            paddingTop: "0px",
                          }}
                        ></span>
                      </OverlayTrigger>
                    </span>
                  }
                  id="group"
                  name="group"
                  type="number"
                  placeholder={3}
                  maxLength={2}
                />
              </Col>
            </Row>
            {/** Show error message */}
            {error && (
              <Row>
                <Col md={12} className="mt-3">
                  <Alert variant="warning">{error}</Alert>
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="cancelAddGrade"
              variant="outline-secondary"
              onClick={() => props.setShowModalAddGrade(false)}
              disabled={isSubmitting}
            >
              {t("global:buttons.cancel")}
            </Button>
            <Button id="saveGrade" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <TextLoading
                  text={t("global:buttons.saving")}
                  variant="light"
                />
              ) : (
                t("class:modalAddGrade.addGrades")
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
}
AddGrade.propTypes = {
  showModalAddGrade: PropTypes.bool, //Required
  setShowModalAddGrade: PropTypes.func, //Required
  getGrades: PropTypes.func,
  data: PropTypes.object,
  setGradesList: PropTypes.func,
};
